export interface TaskSubtaskContentAssigneeSource {
  content_items: ReadonlyArray<{ assignees: readonly string[] }>;
}

export function getTaskSubtaskContentAssignees(
  subtask: TaskSubtaskContentAssigneeSource
) {
  return Array.from(
    new Set(
      subtask.content_items.flatMap((item) => item.assignees).filter(Boolean)
    )
  );
}
